<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-05 17:55:59
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-11 14:23:59
 * @FilePath: \zhucai_user\src\pages\course\child\rightSide.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <dl v-loading="isLoading" class="width340">
    <dt class="BGwhite size16 radius8 gray1 flex pad22 b500 height60px flex between dtTitle">
      最新活动
    </dt>
    <div v-if="activityInfo" class="activityInfo">
      <div class="content">
        {{ activityInfo.Title }}
      </div>
      <div class="Prop">
        <span class="PropName">时间：</span><span class="PropValue time">{{ activityInfo.StartTime }} - {{
          activityInfo.EndTime }}</span>
      </div>
      <div class="Prop mt5">
        <span class="PropName">地点：</span><span class="PropValue">{{ activityInfo.Address }}</span>
      </div>
    </div>
    <div v-else class="info">
      <el-empty description="暂无内容" :image="empty1" />
    </div>

    <dt class="BGwhite size16 radius8 gray1 flex pad22 mt20 b500 height60px between dtTitle">
      相关课程
      <div class="grid2 gap10 part39 center jiantou" v-if="courselist.length > 1">
        <img src="@/assets/img/home/20.png" alt="" class="btn" @click="prev" />
        <img src="@/assets/img/home/19.png" alt="" class="btn" @click="next" />
      </div>
    </dt>
    <div v-if="courselist.length > 0" class="info2">
      <div class="my-table">
        <div class="table-item" @click="toDetail(courseInfo)">
          <div class="img">
            <img :src="courseInfo.ImgPath" @error="imgError" alt="" />
          </div>
          <div class="content">
            {{ courseInfo.CourseName }}
          </div>
          <div class="flex mt10">
            <div class="rate">
              <span class="mr5 mt5">{{ courseInfo.StarNum }}</span>
              <el-rate v-model="courseInfo.StarNum" disabled text-color="#ff9900">
              </el-rate>
            </div>
            <div class="user">
              <img src="@/assets/img/home/4.png" alt="" />{{
                courseInfo.StudyView
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="info">
      <el-empty description="暂无内容" :image="empty1" />
    </div>

    <dt class="BGwhite size16 radius8 gray1 flex mt20 pad22 b500 height60px between dtTitle">
      资料
      <div class="grid2 gap10 part39 center jiantou" v-if="materiallist.length > 1">
        <img src="@/assets/img/home/20.png" alt="" class="btn" @click="prev2" />
        <img src="@/assets/img/home/19.png" alt="" class="btn" @click="next2" />
      </div>
    </dt>
    <div v-if="materiallist.length > 0" class="materialInfo BGwhite radius8 pad22" @click="toDetail2(materialInfo)">
      <div class="flexs">
        <div class="questionBank-left">
          <img v-if="
            materialInfo.FileExt == '.docx' || materialInfo.FileExt == '.doc'
          " src="@/assets/img/home/29.png" alt="" />
          <img v-if="materialInfo.FileExt == '.zip'" src="@/assets/img/home/30.png" alt="" />
          <img v-if="materialInfo.FileExt == '.ppt'" src="@/assets/img/home/31.png" alt="" />
          <img v-if="materialInfo.FileExt == '.rar'" src="@/assets/img/home/32.png" alt="" />
          <img v-if="materialInfo.FileExt == '.txt'" src="@/assets/img/home/33.png" alt="" />
          <img v-if="materialInfo.FileExt == '.7z'" src="@/assets/img/home/34.png" alt="" />
          <img v-if="materialInfo.FileExt == '.pdf'" src="@/assets/img/home/35.png" alt="" />
        </div>
        <div class="questionBank-right">
          <p class="name">
            <span>{{ materialInfo.MaterialName }}</span>
          </p>
          <div class="content">
            <div>{{ materialInfo.MaterialExt }}</div>
            <div>{{ materialInfo.FileSizeTxt }}</div>
          </div>
        </div>
      </div>
      <div class="flex mt15">
        <div class="rate">
          <span class="mr5 mt5">{{ materialInfo.StarNum }}</span>
          <el-rate v-model="materialInfo.StarNum" disabled text-color="#ff9900">
          </el-rate>
        </div>
        <div class="user">
          <img src="@/assets/img/home/4.png" alt="" />{{
            materialInfo.StudyView
          }}
        </div>
      </div>
    </div>
    <div v-else class="info">
      <el-empty description="暂无内容" :image="empty1" />
    </div>
  </dl>
</template>

<script>
import {
  Teacher_GetCourses,
  Teacher_GetMaterials,
  Teacher_GetOthers,
} from "@/api/teacher";
export default {
  name: "demo",
  data() {
    return {
      courselist: [],
      courseInfo: null,
      courseCount: 0,
      page: 0,
      materiallist: [],
      materialInfo: null,
      materialCount: 0,
      page2: 0,
      activityInfo: null,
      isLoading: false,
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path: "/courseDetail",
        query: { CourseID: item.CourseID },
      });
    },
    toDetail2(item) {
      this.$router.push({
        path: "/materialDetail",
        query: { MaterialID: item.MaterialID },
      });
    },
    prev() {
      if (this.page == 0) return;
      this.page--;
      this.courseInfo = this.courselist[this.page];
    },
    next() {
      if (this.page == this.courseCount - 1) return;
      this.page++;
      this.courseInfo = this.courselist[this.page];
    },
    prev2() {
      if (this.page2 == 0) return;
      this.page2--;
      this.materialInfo = this.materiallist[this.page2];
    },
    next2() {
      if (this.page2 == this.materialCount - 1) return;
      this.page2++;
      this.materialInfo = this.materiallist[this.page2];
    },
    getDetail() {
      this.isLoading = true;
      Teacher_GetOthers({
        TeacherID: this.$route.query.TeacherID,
      })
        .then((res) => {
          this.isLoading = false;
          this.activityInfo = res.data[0] || null;
        })
        .finally(() => {
          this.isLoading = false;
        });
      Teacher_GetCourses({ TeacherID: this.$route.query.TeacherID })
        .then((res) => {
          this.isLoading = false;
          this.courselist = res.data;
          this.courseInfo = res.data[0];
          this.courseCount = res.data.length;
        })
        .finally(() => {
          this.isLoading = false;
        });
      Teacher_GetMaterials({
        TeacherID: this.$route.query.TeacherID,
      })
        .then((res) => {
          this.isLoading = false;
          this.materiallist = res.data;
          this.materialInfo = res.data[0];
          this.materialCount = res.data.length;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.width340 {
  width: 340px;
}

.dtTitle {
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 24px;
    left: 0;
    width: 6px;
    height: 20px;
    background: #1d79ff;
    border-radius: 3px;
  }
}

.jiantou {
  .btn {
    cursor: pointer;
    margin-top: -5px;
    width: 28px;
    height: 28px;
  }
}

.info {
  margin-top: 1px;
  width: 340px;
  height: 194px;
  padding: 15px;
  display: flex;
  gap: 20px;
  background: #ffffff;
  border-radius: 10px;

  .info-left {
    width: 130px;
    height: 160px;
    overflow: hidden;
    border-radius: 6px;

    img {
      width: 130px;
      height: 160px;
      border-radius: 6px;
    }
  }

  .info-right {
    position: relative;

    .TeacherName {
      margin-top: 10px;
      font-size: 20px;
      color: #333333;
    }

    .PropValue {
      margin-top: 5px;
      font-size: 16px;
      color: #999999;
    }

    .testBtn {
      position: absolute;
      bottom: 10px;
      height: 36px;
      line-height: 12px;
      background: #ffffff;
      border-radius: 6px;
      font-size: 16px;
      border: 1px solid #cccccc;
    }
  }
}

.info2 {
  margin-top: 1px;
  display: block;

  .table-item {
    cursor: pointer;
    width: 340px;
    padding: 15px;
    background: #ffffff;
    border-radius: 10px;
    margin-bottom: 10px;

    &:hover {
      transform: scale(1.01);
    }

    .content {
      margin-top: 15px;
      font-size: 20px;
      color: #333333;
      display: -webkit-box;
      overflow: hidden;
      /* 超出的文本隐藏 */
      text-overflow: ellipsis;
      /* 溢出用省略号显示 */
      -webkit-box-orient: vertical;
      /* 垂直排列子元素 */
      -webkit-line-clamp: 2;
      /* 显示的行数 */
    }

    .img {
      width: 308px;
      height: 231px;
      border-radius: 6px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .type {
    font-size: 16px;
    color: #999999;
  }

  .amout {
    font-size: 24px;
    font-weight: bold;
  }

  .red {
    font-size: 16px;
    color: #e12a14;
    font-weight: bold;
  }

  .user {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #666666;

    img {
      width: 12px;
      height: 17px;
      margin-right: 9px;
    }
  }

  .rate {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 20px;
    color: #e12a14;
  }
}

.activityInfo {
  padding: 15px;
  margin-top: 1px;
  background: #ffffff;

  .content {
    font-size: 20px;
    color: #333333;
    display: -webkit-box;
    overflow: hidden;
    /* 超出的文本隐藏 */
    text-overflow: ellipsis;
    /* 溢出用省略号显示 */
    -webkit-box-orient: vertical;
    /* 垂直排列子元素 */
    -webkit-line-clamp: 1;
    /* 显示的行数 */
    margin-bottom: 10px;
  }

  .Prop {
    .PropName {
      font-size: 16px;
      color: #999999;
    }

    .PropValue {
      font-size: 16px;
      color: #333333;
    }

    .time {
      color: #1d79ff;
      font-weight: bold;
    }
  }
}

.materialInfo {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;

  .flexs {
    display: flex;
    align-items: center;
    gap: 20px;
    cursor: pointer;

    .questionBank-left {
      width: 42px;
      height: 43px;

      img {
        width: 42px;
        height: 43px;
      }
    }

    .questionBank-right {
      flex: 1;

      .name {
        width: 240px;
        overflow: hidden;
        /* 隐藏超出容器的文本 */
        white-space: nowrap;
        /* 保持文本在一行内显示 */
        text-overflow: ellipsis;
        /* 使用省略号表示文本溢出 */
        font-weight: 400;
        font-size: 20px;
        color: #333333;
      }

      .content {
        display: flex;
        gap: 30px;
        font-size: 16px;
        color: #999999;
      }
    }

    &:hover {
      .questionBank-right {
        .name {
          color: #1d79ff;

          span {
            display: inline-block;
            border-bottom: 1px solid #1d79ff;
          }
        }
      }
    }
  }
}
</style>
